import { Route } from 'vue-router';
import Vue from 'vue';
import _ from '../utils';
import { Guard } from '../plugins/guards/guardWrapper';

export default {
  name: 'RoleGuard',
  async routeBeforeEnter(to: Route, from: Route) {
    try {
      await Vue.$config.promise;
      const requiredRole = await Vue.$routerUtils.getRouteOption<string>(to, 'role');
      if (requiredRole === undefined || requiredRole === null) {
        return undefined;
      }
      let hasRequiredRole = false;
      if (_.isArray(requiredRole)) {
        hasRequiredRole = requiredRole.some((role) => Vue.$auth.isInRole(role));
      } else {
        hasRequiredRole = Vue.$auth.isInRole(requiredRole);
      }
      if (!hasRequiredRole) {
        const redirectRoute = Vue.$config.values['auth-redirects-login'];
        if (!Vue.$routerUtils.areRoutesSame(redirectRoute, to)) {
          // TODO: When an "error system" is available notify the user instead of redirecting
          Vue.$log.info(`👮‍♂️ [RoleGuard]: User does not have correct role '${requiredRole}', redirecting to login`);
          return redirectRoute;
        }
      }
    } catch (error) {
      Vue.$log.error(error);
    }
    return undefined;
  },
} as Guard;
